import Header from '@/components/organisms/Header'

interface DesktopLayoutProps {
  children: React.ReactNode
}

const DesktopLayout = ({ children }: DesktopLayoutProps) => {
  return (
    <div className="min-h-screen bg-[#f2f1f6] dark:bg-[var(--header-bg)] relative">
      <Header />
      
      {/* Main Content */}
      <main className="min-h-screen bg-[#f2f1f6] dark:bg-[var(--header-bg)] relative">
        {children}
      </main>
    </div>
  )
}

export default DesktopLayout 